import { styled } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';
import { ScContainer } from '@/styles/common';
import { device } from '@/styles/helpers';
import { ScScratchActionButton } from '../ScratchActionButton/styled';

const bg = getCDNImageUrl('/scratchGame/bottom-bg.webp');

export const ScBottomDecor = styled.div`
  position: relative;
  padding-bottom: 80px;
  background-image: url(${bg});
  background-size: 1280px 1065px;
  background-position: bottom center;
  background-repeat: no-repeat;
  overflow-x: hidden;

  @media (${device.mobile}) {
    background: none;
    padding-bottom: 32px;
    & > img {
      display: none;
    }
  }

  & > ${ScContainer} {
    position: relative;
    overflow: hidden;
  }

  & .content {
    display: grid;
    gap: 235px;
    @media (${device.mobile}) {
      gap: 80px;
    }
  }

  & ${ScScratchActionButton} {
    margin-top: 24px;
    margin-inline: auto;
  }

  & > .popcorn {
    position: absolute;
    z-index: 1;

    &.left {
      left: -137px;
      bottom: 90px;
    }

    &.right {
      top: 350px;
      right: -130px;
      rotate: -40deg;
    }
  }
`;
